var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero-section"},[_c('div',{staticClass:"hero-bg"},[_c('img',{attrs:{"src":require(`@/assets/images/${_vm.bgImage}`),"alt":"Hero Background"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }